function hasOwnProperty(x, y) {
  return Object.prototype.hasOwnProperty.call(x, y);
}

export { hasOwnProperty };